import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ItemInspecaoFrotaService from "service/gestao/frotas/ItemInspecaoFrotaService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const itemInspecaoFrotaService = new ItemInspecaoFrotaService();

export default function ItemInspecaoFrotaListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Item inspeção');

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    

    return (

        <BaseListagem ordenacao="nome,ASC" service={itemInspecaoFrotaService} urlService="/itemInspecaoFrota" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="itemInspecao" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="vlPeriodicidadeRevisao" header="Valor Periodicidade" />
            <Column field="periodicidade" header="Periodicidade" body={(rowData) => itemInspecaoFrotaService.getPeriodicidade(rowData.periodicidade)} />
            <Column field="intervaloQuilometragemRevisao" header="Intervalo Quilometros" />
            <Column field="intervaloHorasRevisao" header="Intervalo Horas" />
        </BaseListagem>
    )
}